import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    signInFormWrapper: {
        width: 275,
        margin: '0 auto',
        [theme.breakpoints.down('xs')]: {
            width: '90%',
        },
    },
    alertWrapper: {
        bottom: 0,
        padding: theme.spacing(3),
        position: 'absolute',
        right: 0,
        zIndex: 1500,
        maxWidth: '545px',
    },
}));
